<template>
      <v-container fluid>
        <div>
          <h2 style="font-size: 18px; font-weight: 600; padding-bottom: 15px">
            Create Data Models
          </h2>

          <v-row>
            <v-col cols="12">
              <v-card class="pa-5 model-create-card">
                <v-row>
                  <v-col cols="12" class="py-0 mt-4">
                    <v-label class="label">Select Data Source</v-label>
                    <v-col cols="5" class="pa-0">
                      <AutoComplete
                        placeholder="Select Data Source"
                        :showReadOnly="false"
                        v-model="formData.data_source"
                        :items="['internal', 'external']"
                        @input="changesModel"
                      />
                    </v-col>
                  </v-col>

                  <v-col cols="12" class="py-0">
                    <v-label class="label">Select your database table/view</v-label>
                    <v-col cols="5" class="pa-0" style="position: relative">
                      <AutoComplete
                        placeholder="Search Table/View"
                        :name="'value'"
                        :showReadOnly="false"
                        :value="'value'"
                        v-model="formData.model"
                        :items="schemaData"
                        :allow-new="true"
                        @input="changesModeldata"
                      />
                      <v-progress-circular
                        style="position: absolute; right: 34px; top: 0"
                        v-if="resloader"
                        indeterminate
                        color="primary"
                        size="20"
                        class="mt-2"
                      />
                    </v-col>
                  </v-col>

                  <v-col cols="12" class="py-0">
                    <v-label class="label">Give the model a name</v-label>
                    <v-col cols="5" class="pa-0">
                      <TextFieldComponent
                        class="text-fill"
                        @input="changesModel"
                        v-model="formData.name"
                        placeholder="Name of the model"
                      ></TextFieldComponent>
                      <span v-if="errorFalse && formData.name" class="error-list"
                        >Already Exists!</span
                      >
                    </v-col>
                  </v-col>

                  <v-col class="dialogBottom" cols="12" align="end">
                    <v-btn @click="cancel" class="mr-2" color="#f4f4f4" :width="140">Cancel</v-btn>
                    <v-btn @click="handleSave" :loading="saveLoader" class="save" :width="140">Create</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-snackbar v-model="snackbar" :timeout="4000" location="top" color="primary">
            {{ snackbarText }}
          </v-snackbar>
        </div>
      </v-container>
</template>

<script>
import { AutoComplete } from "@tiburadev/vue-comp3";
import { TextFieldComponent } from "@tiburadev/vue-comp3";
import clientDetailsService from "@/api/service/ClientDetails/ClientDetailsService";
import DataModelsService from "@/api/service/DataModel/DataModelsService";

// import debounce from "lodash/debounce";
// import Table from "./Table.vue";
// import StoredProcedure from "./models/StoredProcedure.vue";
// import Query from "./models/Query.vue";
// import ExcelFiles from "./models/ExcelFiles.vue";
// import Api from "./models/Api.vue";
// import MultipleModel from "./models/MultipleModel.vue";
// import FixedTable from "./models/FixedTable.vue";
// import EnvisionReport from "./models/EnvisionReport.vue";
// import Files from "./models/Files.vue";

// import CommonService from "../api/service/common-service";
// import DataModelsService from "../api/service/data-models-service";
// import CompanieService from "../api/service/companieService";
// import EnumApiService from "../../api/service/Enum/EnumService";

export default {
  name: "CreateDataModel",

  components: {
    AutoComplete,
    TextFieldComponent,
  },
  data() {
    return {
      selectedIndex: "tables",
      snackbar: false,
      errorFalse: false,
      schemaData: [],
      modelData: [],
      companyData: [],
      snackbarText: null,
      saveLoader: false,
      createModel: [],
      formData: { model_type: "Table" },

      // dataModelData: [
      //   { label: "Tables", isActive: true, icon: "mdi mdi-database", id: "tables" },
      //   { label: "Stored Procedure", isActive: true, id: "stored_procedure", icon: "mdi mdi-format-list-text" },
      //   { label: "Query", isActive: true, id: "query", icon: "mdi mdi-console" },
      //   { label: "Excel Files", isActive: false, id: "excel_files", icon: "mdi mdi-database" },
      //   { label: "Files", isActive: false, id: "files", icon: "mdi mdi-map-outline" },
      //   { label: "API", isActive: false, id: "api", icon: "mdi mdi-format-list-text" },
      //   { label: "Multiple Model", isActive: true, id: "multiple_model", icon: "mdi mdi-zip-box-outline" },
      //   { label: "JSON Model", isActive: false, id: "json_model", icon: "mdi mdi-code-json" },
      //   { label: "Fixed Table", isActive: true, id: "fixed_table", icon: "mdi mdi-table" },
      //   { label: "Envision Report", isActive: false, id: "envision_report", icon: "mdi mdi-window-maximize" },
      // ],
    };
  },

  // computed: {
  //   filteredDataModelData() {
  //     console.log(this.createModel,'wertyuio')
  //     const allowed = this.createModel.map(x => x.data_value);
  //     return this.dataModelData.filter(item => allowed.includes(item.id));
  //   }
  // },

  watch: {
    "formData.search"(newVal) {
      if (this.formData.data_source && newVal) {
        this.debouncedGetModelData(this.formData.data_source, newVal);
      }
    },

    "formData.data_source"(newVal) {
      if (newVal) {
        this.modelData = [];
      }
    }
  },

  created() {
    // this.debouncedGetModelData = debounce(this.getModelData, 1000);
  },

  mounted() {
    this.getEnum();
    this.getCompaniesData();
    this.getSchema();
  },

  // beforeDestroy() {
  //   // this.debouncedGetModelData.cancel();
  // },

  methods: {
    async getEnum() {
      try {
      //   const res = await EnumApiService.findAll({
      //     domain: "DATA-MODEL-TYPE",
      //     deleted: 0,
      //     active: 1,
      //   });
      //   this.createModel = res;
      } catch (e) {
        console.error("Enum fetch failed", e);
      }
    },

    // async getModelData(data, search) {
    //   // this.modelData = [];
    //   // const res = await CommonService.getTables({ data_source: data, search });
    //   // this.modelData = res.length ? res : [];
    // },

    async getCompaniesData() {
      // const res = await CompanieService.getAll({ deleted: 0 });
      // this.companyData = res.length ? res : [];
    },
    cancel() {
      this.formData = {}
      this.$router.push("/datamodel");
    },
    async getSchema() {
      this.schemaData = await clientDetailsService.getSchemaList({ collectionName: 'organisation' })
      console.log(this.schemaData, 'schemaaa')
    },

    changeData(value) {
      this.errorFalse = false;
      this.formData = value;
      this.formData.model_type = this.selectedIndex;
    },

    cardSelect(dataModel) {
      this.selectedIndex = dataModel.id;
      this.formData.model_type = dataModel.id;
    },

    changesModel() {
      // Handle input changes
    },

    async handleSave() {
      this.saveLoader = true
      console.log(this.formData,"addmodel");
      const modelData = await DataModelsService.create(this.formData)
      console.log(modelData,"mdmdmdmdmdm");
      this.saveLoader = false
      this.formData = {}
      this.snackbarText = "DataModel Created Successfully";
      this.snackbar = true;
      this.$router.push("/datamodel")
      // const data = await DataModelsService.getAll({ deleted: 0 });

      // if (this.formData.name) {
      //   const exists = data.filter(
      //     x => x.name.toLowerCase() === this.formData.name.toLowerCase()
      //   );

      //   if (exists.length === 0) {
      //     this.saveLoader = true;

      //     this.formData.roles = JSON.stringify(this.formData.roles);
      //     delete this.formData.search;

      //     let res;

      //     if (this.formData.id) {
      //       await DataModelsService.updateOne(this.formData);
      //       this.snackbarText = "DataModel Updated Successfully";
      //     } else {
      //       if (this.formData.model_type === "json_model") {
      //         this.formData.jsonFile = JSON.stringify(this.formData.jsonFile);
      //       }
      //       res = await DataModelsService.create(this.formData);
      //       this.snackbarText = "DataModel Created Successfully";
      //     }

      //     this.snackbar = true;
      //     this.saveLoader = false;
      //     this.formData = {};
      //   } else {
      //     this.errorFalse = true;
      //   }
      // }
    },
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: inherit !important;
  border-radius: 12px !important;
}
.model-card {
  border: 1px solid lightgray;
}
.select-card {
  border: 2px solid #0f62fe;
}
.working-card {
  border: 2px solid #fe0f0f;
}
</style>
